export { default } from './SpeedometerOutline'
